import { Checkbox } from "@chakra-ui/react";

import { AccessRule } from "@/api";
import { useStatusQuery } from "@/queries/query-status";

import { useSetUserWriteAccess } from "../api/set-user-write-access";

export const UserWriteAccessToggle = ({ user }: { user: AccessRule }) => {
  const { writeAccess } = user;
  const { mutate, isPending } = useSetUserWriteAccess();
  const statusResponse = useStatusQuery();

  const isAdmin = statusResponse.data?.authenticated && statusResponse.data?.hasAdminAccess;
  const label = writeAccess ? "ja" : "nee";

  if (!isAdmin) return label;

  return (
    <Checkbox
      onChange={(e) => {
        mutate({
          id: user.id,
          email: user.email,
          writeAccess: e.target.checked,
        });
      }}
      isChecked={writeAccess}
      isDisabled={isPending}
    >
      {label}
    </Checkbox>
  );
};
